/**
 * The codes bill automation stores for a bill it held because of what the Billing tab already has (LB-6094). A bill
 * held for its billing was read and matched to its property in full: it waits for review, not for a property.
 */
const BILLING_HOLD_CODES = ['BillingOverlap', 'BilledCheckUnavailable'];
const ALREADY_BILLED_CODE = 'AlreadyBilled';

/**
 * The reason bill automation stores on an emailed bill it holds, unread, for the company's plan (LB-6231): a bare slug,
 * as its other email holds store theirs.
 */
const HELD_FOR_PLAN_REASON = 'tier-required';

/** Each stored reason's code, or null for a reason stored without one. */
const codesOf = errors => (errors || []).map(error => {
  var _exec$, _exec;
  return (_exec$ = (_exec = /^\[([^\]]+)\]/.exec(String(error))) === null || _exec === void 0 ? void 0 : _exec[1]) !== null && _exec$ !== void 0 ? _exec$ : null;
});

/**
 * Whether a bill's stored reasons say it's held for the company's plan. The bill's own read carries no hold, so a bill
 * opened by a link before the list has its row is known by this.
 */
export const isHeldForPlanReason = errors => (errors || []).some(error => String(error) === HELD_FOR_PLAN_REASON);

/**
 * The title and the line under it on a bill's problem banner, by its status and, for a bill set aside or held because
 * of its billing or its company's plan, by the reason stored on it.
 */
export function billStatusBannerCopy(_ref) {
  let errors = _ref.errors,
    isDuplicate = _ref.isDuplicate,
    isHeldForPlan = _ref.isHeldForPlan,
    isRejected = _ref.isRejected,
    needsProperty = _ref.needsProperty;
  const codes = codesOf(errors);
  if (isDuplicate) {
    return codes.includes(ALREADY_BILLED_CODE) ? {
      title: 'This bill is a duplicate',
      intro: 'It was not processed, because its period is already billed:'
    } : {
      title: 'This bill is a duplicate',
      intro: 'It was not processed, because the company already holds it:'
    };
  }
  if (isRejected) {
    // Held for the plan (LB-6233), there's nothing to review: the upgrade is what reads it.
    return isHeldForPlan ? {
      title: 'This bill is held until you upgrade',
      intro: 'We didn’t read it, because:'
    } : {
      title: 'This bill is held for your review',
      intro: 'We didn’t read it, because:'
    };
  }
  if (needsProperty) {
    // Every reason has to be a billing one: any other, coded or not, is about the property.
    const heldForBilling = codes.length > 0 && codes.every(code => BILLING_HOLD_CODES.includes(code));
    return {
      title: heldForBilling ? 'This bill needs review' : 'This bill needs a property',
      intro: 'We read it, but:'
    };
  }
  return {
    title: 'This bill couldn’t be processed',
    intro: 'Here’s why:'
  };
}